import { ActionState, ActionStateEnum, IdleConstruction } from "..";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { DimensionNode } from "../../plan/Nodes/DimensionNode";

import { PlanManager } from "../../../../cocosPlan";
import { Commands, Entity, EntityDefaultPropertiesManager, Events, eventsManager, Joinery, math, SavaneConstants, SavaneMath, Staircase, TechnicalElement, Wall, wallManager } from "@rhinov/savane-js";

declare var bootbox: any;
declare var $: any;


const EditionSens = {
    begin: 0,
    end: 1,
    both: 2
};

export class EditCoteState extends ActionState {

    state: number = ActionStateEnum.EditCote;
    dimension: DimensionNode | null = GameObjectManager.dimensionClicked;
    dimensionType: number = GameObjectManager.dimensionClickedType;

    editedWallList: Wall[] | null = null;
    editedWall: Wall | null = null;
    editedWallsSides: any = null;
    editedWallsBegin: Wall[] = [];
    editedWallsEnd: Wall[] = [];

    editedTechElement: TechnicalElement | null = null;
    techEditDir: string | null = null;
    editedJoinery: Joinery | null = null;

    editionSens: number = 0;
    editionDone: boolean = false;
    lengthCm: number = -1;
    prevLengthCm: number = -1;

    constructor(obj: {join?: Joinery, techElem?: TechnicalElement[], dir?: string}) {
        super();

        this.dimension!.editionStart();
       
        switch (this.dimensionType) {
            case GameObjectManager.DimensionType.Joinery1:
            case GameObjectManager.DimensionType.Joinery2:
            case GameObjectManager.DimensionType.Joinery3:
                this.editedJoinery = obj as Joinery;
                this.editedJoinery!.startTemporary();
                break;
            case GameObjectManager.DimensionType.TechElement:
                this.editedTechElement = obj.techElem![0];
                if (obj.dir === 'width') {
                    obj.dir = 'length';
                }
                else {
                    obj.dir = 'width';
                }
                this.techEditDir = obj.dir;
                this.editedTechElement!.startTemporary();
                break;
            default:
                break;
        }
        this.commitChange();
    }

    getAction (): number {
        return ActionStateEnum.EditCote;
    }

    mouseClickDown (cursorPosition: math.vec3, doubleClick: boolean, hoverEntities: Entity[], mouseButton: number): ActionState | null {
        if (mouseButton === 2) {
            return PlanManager.getInstance().mouseClickCancelled();
        }
        //   this.commitChange();
        return null;
    }

    moveMouseCursor (cursorPosition: math.vec3, hoverEntities?: Entity[], planpos?: math.vec3) {
        super.moveMouseCursor(cursorPosition, hoverEntities, planpos);
        if (this.editionDone) {
            return new IdleConstruction();
        }
        return null;
    }

    mouseIdle (cursorPosition: math.vec3, hoverEntities: Entity[], dt: number): ActionState | null {
        return null;
    }

    isLengthValid (): boolean {
        if (this.editedJoinery === null) {
            if (this.lengthCm < 10 || this.lengthCm > 3000) {
                return false;
            }
        } else {
            switch (this.dimensionType) {
                case GameObjectManager.DimensionType.Joinery1:
                case GameObjectManager.DimensionType.Joinery3:
                    if (this.lengthCm < 0 || this.lengthCm > 3000) {
                        return false;
                    }
                    break;
                case GameObjectManager.DimensionType.Joinery2:
                    if (this.lengthCm < 30) {
                        return false;
                    }
                    break;
                case GameObjectManager.DimensionType.TechElement:
                    if (this.lengthCm < 20) {
                        return false;
                    }
            }
        }
        return true;
    }

    commitChange () {
        var buttons: any = {};
        buttons.cancel = {
            label: 'Annuler',//'Annuler',
            className: 'btn btn-link',
            callback: () => this.endEdition()
        };
        if (this.dimensionType === GameObjectManager.DimensionType.Walls) {
            var name1 = '';
            var name2 = '';
            var direction = math.vec3.create();
            //compute distance of walls list
            if (this.editedWallsSides[0]) {
                if (this.editedWallsSides[this.editedWallsSides.length - 1]) {
                    math.vec3.subtract(direction, this.editedWallList![0].end, this.editedWallList![this.editedWallList!.length - 1].begin);
                } else {
                    math.vec3.subtract(direction, this.editedWallList![0].begin, this.editedWallList![this.editedWallList!.length - 1].begin);
                }
            } else {
                if (this.editedWallsSides[this.editedWallsSides.length - 1]) {
                    math.vec3.subtract(direction, this.editedWallList![0].end, this.editedWallList![this.editedWallList!.length - 1].end);
                } else {
                    math.vec3.subtract(direction, this.editedWallList![0].begin, this.editedWallList![this.editedWallList!.length - 1].end);
                }
            }
            if (Math.abs(direction[1]) < Math.abs(direction[0])) {
                name1 = 'Appliquer à gauche';//'Gauche';
                name2 = 'Appliquer à droite';//'Droite';
            } else {
                name1 = 'Appliquer en haut';//'Haut';
                name2 = 'Appliquer en bas';//'Bas';
            }
            buttons.Button1 = {
                label: name1,
                className: 'btn btn-link btn-yes',
                callback: () => {
                    //Check for direction upd/down || left/right
                    if (Math.abs(direction[1]) < Math.abs(direction[0])) {
                        //Find modified wall in list
                        if (direction[0] < 0) {
                            //First wall of list
                            this.editedWall = this.editedWallList![0];
                        } else {
                            //Last wall of list
                            this.editedWall = this.editedWallList![this.editedWallList!.length - 1];
                        }
                        //check wall for modification side
                        if (this.editedWall!.wallDirection[0] > 0) {
                            this.editionSens = EditionSens.begin;
                        } else {
                            this.editionSens = EditionSens.end;
                        }
                    } else {
                        if (direction[1] > 0) {
                            //First wall of list
                            this.editedWall = this.editedWallList![0];
                        } else {
                            //Last wall of list
                            this.editedWall = this.editedWallList![this.editedWallList!.length - 1];
                        }
                        if (this.editedWall!.wallDirection[1] < 0) {
                            this.editionSens = EditionSens.begin;
                        } else {
                            this.editionSens = EditionSens.end;
                        }
                    }
                    this.findWallsEdited();
                    if (this.isLengthValid()) {
                        this.testEdit();
                    } else {
                        this.affError();
                    }
                }
            };
            buttons.Button2 = {
                label: name2,
                className: 'btn btn-link btn-yes',
                callback: () => {
                    //Check for direction upd/down || left/rights
                    if (Math.abs(direction[1]) < Math.abs(direction[0])) {
                        if (direction[0] > 0) {
                            //First wall of list
                            this.editedWall = this.editedWallList![0];
                        } else {
                            //Last wall of list
                            this.editedWall = this.editedWallList![this.editedWallList!.length - 1];
                        }
                        if (this.editedWall!.wallDirection[0] < 0) {
                            this.editionSens = EditionSens.begin;
                        } else {
                            this.editionSens = EditionSens.end;
                        }
                    } else {
                        if (direction[1] < 0) {
                            //First wall of list
                            this.editedWall = this.editedWallList![0];
                        } else {
                            //Last wall of list
                            this.editedWall = this.editedWallList![this.editedWallList!.length - 1];
                        }
                        if (this.editedWall!.wallDirection[1] > 0) {
                            this.editionSens = EditionSens.begin;
                        } else {
                            this.editionSens = EditionSens.end;
                        }
                    }
                    this.findWallsEdited();
                    if (this.isLengthValid()) {
                        this.testEdit();
                    } else {
                        this.affError();
                    }
                }
            };
        } else {
            buttons.valid = {
                label: 'Valider',
                className: 'btn btn-link btn-yes',
                callback: () => {
                    if (this.isLengthValid()) {
                        this.testEdit();
                    } else {
                        this.affError();
                    }
                }
            };
        }
        var placeholder = this.dimension!.dimensionLabel.getString().substr(0, this.dimension!.dimensionLabel.getString());
        //FIXME Dirty we should not use bootbox here
        if (typeof bootbox !== 'undefined') {
            bootbox.dialog({
                className: 'editCote',
                title: 'Dimensions',
                message: '<div class="bootbox-form"  novalidate>' +
                    '<input class="bootbox-input bootbox-input-text form-control" autocomplete="off" autofocus=true type="number" id="coteInput" placeholder="'
                    + placeholder + '">' +
                    '</div>',
                buttons: buttons,
                onEscape: () => this.endEdition()
            }).off('shown.bs.modal').on('shown.bs.modal', function () {
                $('#coteInput').focus();
            });

            $('#coteInput').on('input', (event: any) => {
                var value = $('#coteInput').val();
                if (this.lengthCm === -1) {
                    this.prevLengthCm = this.dimension!.dimensionValue;
                }
                if (!isNaN(value) && value !== undefined && value !== null && value !== '') {
                    this.lengthCm = parseInt(value);
                }
            });
        } else {
            eventsManager.instance.dispatch(Events.EDIT_DIMENSION);
        }
    }
    endEdition () {
        var i;
        for (i = 0; i < this.editedWallsBegin.length; i++) {
            this.editedWallsBegin[i].endTemporary();
        }
        for (i = 0; i < this.editedWallsEnd.length; i++) {
            this.editedWallsEnd[i].endTemporary();
        }
        if (this.editedWallList !== null)
            for (i = 0; i < this.editedWallList!.length; ++i) {
                this.editedWallList[i].endTemporary();
            }
        if (this.editedJoinery !== null) {
            this.editedJoinery!.endTemporary();
        }
        if (this.editedTechElement !== null) {
            this.editedTechElement!.endTemporary();
        }
        this.editionDone = true;
        this.dimension!.editionEnd();
        PlanManager.getInstance().updateItemsSelected(null);
    }
    affError () {
        bootbox.alert('Certaines contraintes ne permettent pas d\'effectuer cette opération, veuillez vérifier que votre édition conserve l\'intégrité du plan (murs, menuiseries, éléments techniques,...)', () => {

        });
        this.endEdition();
    }

    testEdit () {
        var i;
        if (this.updateObject()) {
            PlanManager.getInstance().updateItemsSelected(null);
            this.editionDone = true;
            this.dimension!.editionEnd();
            var planManager = PlanManager.getInstance();
            switch (this.dimensionType) {
                case GameObjectManager.DimensionType.Joinery1:
                case GameObjectManager.DimensionType.Joinery2:
                case GameObjectManager.DimensionType.Joinery3:
                    EntityDefaultPropertiesManager.getInstance().setJoineryDefaultProperties(this.editedJoinery!);
                    planManager.executeCommand(new Commands.EditJoineryCommand(this.editedJoinery!));
                    break;
                case GameObjectManager.DimensionType.TechElement:
                    if (this.editedTechElement!.isTechnicalElementEntity()) {
                        planManager.executeCommand(new Commands.EditTechnicalElementCommand(this.editedTechElement!));
                    } else if (this.editedTechElement!.isStaircaseEntity()) {
                        planManager.executeCommand(new Commands.EditStaircaseCommand(this.editedTechElement as Staircase));
                    }
                    break;
                case GameObjectManager.DimensionType.Walls:
                    var beginPointAfter = this.editedWall!.begin;
                    var endPointAfter = this.editedWall!.end;
                    for (i = 0; i < this.editedWallList!.length; i++)
                        this.editedWallList![i].endTemporary();
                    var beginPointBefore = this.editedWall!.begin;
                    var endPointBefore = this.editedWall!.end;

                    for (i = 0; i < this.editedWallsBegin.length; i++) {
                        this.editedWallsBegin[i].endTemporary();
                    }
                    for (i = 0; i < this.editedWallsEnd.length; i++) {
                        this.editedWallsEnd[i].endTemporary();
                    }

                    switch (this.editionSens) {
                        case EditionSens.begin:
                            planManager.executeCommand(new Commands.EditPointCommand(beginPointBefore, beginPointAfter, PlanManager.getInstance().world.currentScene!.currentFloor!, PlanManager.getInstance().selectedEntities));
                            break;
                        case EditionSens.end:
                            planManager.executeCommand(new Commands.EditPointCommand(endPointBefore, endPointAfter, PlanManager.getInstance().world.currentScene!.currentFloor!, PlanManager.getInstance().selectedEntities));
                            break;
                        case EditionSens.both:
                            planManager.executeCommand(new Commands.EditPointCommand(beginPointBefore, beginPointAfter, PlanManager.getInstance().world.currentScene!.currentFloor!, PlanManager.getInstance().selectedEntities));
                            planManager.executeCommand(new Commands.EditPointCommand(endPointBefore, endPointAfter, PlanManager.getInstance().world.currentScene!.currentFloor!, PlanManager.getInstance().selectedEntities));
                            break;
                        default:
                            break;
                    }
                    break;
                default:
                    break;
            }
        } else {
            this.affError();
        }
    }
    /**
     * fill editedWallsBegin and editedWallsEnd depending of the parameters of the edition (editionSens )
     */
    findWallsEdited () {
        var i, j;
        var walls;
        if (this.editionSens === EditionSens.begin || this.editionSens === EditionSens.both) {
            walls = wallManager.getWallsAtCorner(this.editedWall!.begin, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance);
            if (walls !== null) {
                for (i = 0; i < walls.length; i++) {
                    walls[i].startTemporary();
                    this.editedWallsBegin.push(walls[i]);
                }
            }
        }
        if (this.editionSens === EditionSens.end || this.editionSens === EditionSens.both) {
            walls = wallManager.getWallsAtCorner(this.editedWall!.end, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance);
            if (walls !== null) {
                for (i = 0; i < walls.length; i++) {
                    if (walls[i].id === this.editedWall!.id && this.editionSens === EditionSens.both) {
                        for (j = 0; j < this.editedWallsBegin.length; j++) {
                            if (this.editedWallsBegin[j].id === this.editedWall!.id) {
                                break;
                            }
                        }
                        this.editedWallsEnd.push(this.editedWallsBegin[j]);
                    } else {
                        walls[i].startTemporary();
                        this.editedWallsEnd.push(walls[i]);
                    }
                }
            }
        }
    }

    /**
     * test whether the edition is valid
     */
    updateObject (): boolean {
        var i;
        var position;
        var isValid = false;
        switch (this.dimensionType) {
            case GameObjectManager.DimensionType.Joinery1:
                var beginPoint = this.editedJoinery!.wall.begin;
                var distToWall = math.vec2.distance(beginPoint, this.editedJoinery!.position) - this.editedJoinery!.length / 2;
                var distLostByWallCornerAngle = distToWall - (this.dimension!.dimensionValue * 10);
                var wall = this.editedJoinery!.wall;

                var beginJoinery = math.vec3.create();
                math.vec3.set(beginJoinery, wall.begin[0] + wall.wallDirection[0] * distToWall, wall.begin[1] + wall.wallDirection[1] * distToWall, 0);

                for (i = 0; i < wall.joineries.length; i++) {
                    if (wall.joineries[i].id !== this.editedJoinery!.id) {
                        if (math.vec3.dist(wall.begin, wall.joineries[i].position) + wall.joineries[i].length / 2 < distToWall) {
                            if (math.vec3.dist(wall.joineries[i].position, beginJoinery) + wall.joineries[i].length / 2 < math.vec3.dist(beginPoint, beginJoinery)) {
                                math.vec3.set(beginPoint, wall.joineries[i].position[0] + wall.wallDirection[0] * wall.joineries[i].length / 2,
                                    wall.joineries[i].position[1] + wall.wallDirection[1] * wall.joineries[i].length / 2, 0);
                            }
                        }
                    }
                }

                position = math.vec3.create();
                math.vec3.set(position, beginPoint[0] + this.editedJoinery!.wall.wallDirection[0] *
                    (this.lengthCm * 10 + this.editedJoinery!.length / 2 + distLostByWallCornerAngle),
                    beginPoint[1] + this.editedJoinery!.wall.wallDirection[1] *
                    (this.lengthCm * 10 + this.editedJoinery!.length / 2 + distLostByWallCornerAngle),
                    this.editedJoinery!.position[2]
                );

                this.editedJoinery!.position = position;
                isValid = this.editedJoinery!.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!);

                break;
            case GameObjectManager.DimensionType.Joinery2:
                this.editedJoinery!.length = this.lengthCm * 10;

                isValid = this.editedJoinery!.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!);
                if (isValid === false && this.lengthCm * 10 < this.editedJoinery!.wall.length) {
                    var joineries = this.editedJoinery!.wall.joineries;
                    var closeTop = this.editedJoinery!.wall.length;
                    var closeBot = 0;
                    for (i = 0; i < joineries.length; ++i) {
                        if (joineries[i].transform.localPosition[0] < closeTop && joineries[i].transform.localPosition[0] > this.editedJoinery!.transform.localPosition[0]) {
                            closeTop = joineries[i].transform.localPosition[0] - joineries[i].length / 2;
                        }
                        if (joineries[i].transform.localPosition[0] > closeBot && joineries[i].transform.localPosition[0] < this.editedJoinery!.transform.localPosition[0]) {
                            closeBot = joineries[i].transform.localPosition[0] + joineries[i].length / 2;
                        }

                    }
                    var newPos = math.vec3.create();
                    var alignTop = closeTop - this.lengthCm * 5 - 10;
                    var alignBot = closeBot + this.lengthCm * 5 + 10;

                    var diffTop = Math.abs(alignTop - this.editedJoinery!.transform.localPosition[0]);
                    var diffBot = Math.abs(alignBot - this.editedJoinery!.transform.localPosition[0]);
                    newPos[0] = diffTop < diffBot ? alignTop : alignBot;
                    newPos[1] = this.editedJoinery!.transform.localPosition[1];
                    newPos[2] = this.editedJoinery!.transform.localPosition[2];

                    this.editedJoinery!.transform.localPosition = newPos;

                    isValid = this.editedJoinery!.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!);
                }
                break;
            case GameObjectManager.DimensionType.TechElement:
                if (this.editedTechElement!.temporary === null) {
                    this.editedTechElement!.startTemporary();
                }
                var diff = this.lengthCm * 10 - (this.editedTechElement as any)[this.techEditDir!];
                (this.editedTechElement as any)[this.techEditDir!] = this.lengthCm * 10;
                // if (this.editedTechElement!.gap !== undefined) {
                //     this.editedTechElement!.gap += diff;
                // }
                isValid = this.editedTechElement!.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!);
                break;
            case GameObjectManager.DimensionType.Joinery3:
                var endPoint = this.editedJoinery!.wall.end;
                distToWall = math.vec2.distance(endPoint, this.editedJoinery!.position) - this.editedJoinery!.length / 2;
                distLostByWallCornerAngle = distToWall - (this.dimension!.dimensionValue * 10);
                wall = this.editedJoinery!.wall;

                var endJoinery = math.vec3.create();
                math.vec3.set(endJoinery, wall.begin[0] + wall.wallDirection[0] * (distToWall + this.editedJoinery!.length), wall.begin[1] + wall.wallDirection[1] * (distToWall + this.editedJoinery!.length), 0);

                for (i = 0; i < wall.joineries.length; i++) {
                    if (wall.joineries[i].id !== this.editedJoinery!.id) {
                        if (math.vec3.dist(wall.end, wall.joineries[i].position) + wall.joineries[i].length / 2 < distToWall) {
                            if (math.vec3.dist(wall.joineries[i].position, endJoinery) + wall.joineries[i].length / 2 < math.vec3.dist(endPoint, endJoinery)) {
                                math.vec3.set(endPoint, wall.joineries[i].position[0] - wall.wallDirection[0] * wall.joineries[i].length / 2,
                                    wall.joineries[i].position[1] - wall.wallDirection[1] * wall.joineries[i].length / 2, 0);
                            }
                        }
                    }
                }

                position = math.vec3.create();
                math.vec3.set(position, endPoint[0] - this.editedJoinery!.wall.wallDirection[0] *
                    (this.lengthCm * 10 + this.editedJoinery!.length / 2 + distLostByWallCornerAngle),
                    endPoint[1] - this.editedJoinery!.wall.wallDirection[1] *
                    (this.lengthCm * 10 + this.editedJoinery!.length / 2 + distLostByWallCornerAngle),
                    this.editedJoinery!.position[2]
                );

                this.editedJoinery!.position = position;
                isValid = this.editedJoinery!.isValid(PlanManager.getInstance().world.currentScene!.currentFloor!);


                break;
            case GameObjectManager.DimensionType.Walls:
                this.editPoint();
                isValid = true;
                for (i = 0; i < this.editedWallsBegin.length; i++) {
                    if (!this.editedWallsBegin[i].isValid(PlanManager.getInstance().world.currentScene!.currentFloor!)) {
                        isValid = false;
                    }
                }
                for (i = 0; i < this.editedWallsEnd.length; i++) {
                    if (!this.editedWallsEnd[i].isValid(PlanManager.getInstance().world.currentScene!.currentFloor!)) {
                        isValid = false;
                    }
                }
                break;
            default:
                break;
        }
        return isValid;
    }
    editDirection (wall: Wall, isBegin: boolean) {
        var otherBoundingBox;
        var lengthVariation = this.prevLengthCm - this.lengthCm;
        var ordonatedWall = wallManager.getWallsAtPositionAngleOrdered(isBegin ? wall.begin : wall.end, PlanManager.getInstance().world.currentScene!.currentFloor!, SavaneConstants.PositionTolerance);
        if (ordonatedWall.length > 1) {
            var boundingbox = this.editedWall!.boundingBox;
            var otherWall;
            var pointA;
            var opposateExtrem;
            var otherWallSide;
            if (this.editedWallsSides[0]) {
                otherWall = ordonatedWall[(ordonatedWall.indexOf(wall) + 1) % ordonatedWall.length];
                otherBoundingBox = otherWall.boundingBox;
                otherWallSide = otherWall.isBegin(isBegin ? wall.begin : wall.end);
                //XOR operand to invert logic for end and begin
                if (otherWallSide === isBegin) {
                    pointA = SavaneMath.getCrossPoint(boundingbox[0], boundingbox[3], otherBoundingBox[1], otherBoundingBox[2]);
                } else {
                    pointA = SavaneMath.getCrossPoint(boundingbox[0], boundingbox[3], otherBoundingBox[0], otherBoundingBox[3]);
                }
                if (isBegin) {
                    opposateExtrem = boundingbox[3];
                } else {
                    opposateExtrem = boundingbox[0];
                }

            } else {
                otherWall = ordonatedWall[(ordonatedWall.indexOf(wall) - 1 + ordonatedWall.length) % ordonatedWall.length];
                otherBoundingBox = otherWall.boundingBox;
                otherWallSide = otherWall.isBegin(isBegin ? wall.begin : wall.end);
                //XOR operand to invert logic for end and begin
                if (otherWallSide === isBegin) {
                    pointA = SavaneMath.getCrossPoint(boundingbox[1], boundingbox[2], otherBoundingBox[3], otherBoundingBox[0]);
                } else {
                    pointA = SavaneMath.getCrossPoint(boundingbox[1], boundingbox[2], otherBoundingBox[2], otherBoundingBox[1]);
                }
                if (isBegin) {
                    opposateExtrem = boundingbox[2];
                } else {
                    opposateExtrem = boundingbox[1];
                }
            }
            if (pointA === null) {
                //Colinear walls swap to normal edition
                this.linearEdit();
                return null;
            }
            var thirdPoint;
            if (otherWallSide) {
                thirdPoint = otherWall.end;
            } else {
                thirdPoint = otherWall.begin;
            }
            var distanceRate = math.vec3.distance(otherWallSide ? otherWall.begin : otherWall.end, isBegin ? wall.end : wall.begin) / math.vec3.distance(opposateExtrem, pointA);
            var direction = wall.wallDirection;

            //Move point of variation
            if (isBegin) {
                pointA[0] += lengthVariation * 10 * direction[0];
                pointA[1] += lengthVariation * 10 * direction[1];
            } else {
                pointA[0] -= lengthVariation * 10 * direction[0];
                pointA[1] -= lengthVariation * 10 * direction[1];
            }
            //Center between
            var centerB = math.vec3.create();
            var distX = (thirdPoint[0] - pointA[0]) / 2;
            var distY = (thirdPoint[1] - pointA[1]) / 2;
            var dist = Math.sqrt((distX * distX) + (distY * distY));
            math.vec3.set(centerB, pointA[0] + distX, pointA[1] + distY, 0);
            //Find the intersections points
            var intersections = SavaneMath.intersctionsCircle(pointA, otherWall.thickness * 0.5, centerB, dist);
            if (!intersections) return null;
            //New distance
            var distanceRateModified = math.vec3.distance(intersections[0], isBegin ? wall.end : wall.begin) / math.vec3.distance(opposateExtrem, pointA);
            var point;
            if ((distanceRate > 1.0 && distanceRateModified > 1.0) || (distanceRate <= 1.0 && distanceRateModified <= 1.0)) {
                point = SavaneMath.getCrossPoint(wall.begin, wall.end, intersections[0], thirdPoint);
            } else {
                point = SavaneMath.getCrossPoint(wall.begin, wall.end, intersections[1], thirdPoint);
            }
            return point;
        } else {
            return null;
        }
    }
    /**
     * edit this.wallEdited to have the chosen dimension
     */
    editPoint () {

        switch (this.editionSens) {
            case EditionSens.begin:
                var newBegin = this.editDirection(this.editedWall!, true);
                if (newBegin === null) {
                    this.linearEdit();
                } else {
                    this.updateWall(newBegin, this.editedWall!.end);
                }
                break;
            case EditionSens.end:
                var newEnd = this.editDirection(this.editedWall!, false);
                if (newEnd === null) {
                    this.linearEdit();
                } else {
                    this.updateWall(this.editedWall!.begin, newEnd);
                }
                break;
            case EditionSens.both:
                console.log('Not implemented');
                break;
        }
    }
    linearEdit () {
        var lengthVariation = this.prevLengthCm - this.lengthCm;
        var direction;
        switch (this.editionSens) {
            case EditionSens.begin:
                var newBegin = this.editedWall!.begin;
                direction = this.editedWall!.wallDirection;
                //Move point of variation
                newBegin[0] += lengthVariation * 10 * direction[0];
                newBegin[1] += lengthVariation * 10 * direction[1];
                this.updateWall(newBegin, this.editedWall!.end);
                break;
            case EditionSens.end:
                var newEnd = this.editedWall!.end;
                direction = this.editedWall!.wallDirection;
                //Move point of variation
                newEnd[0] -= lengthVariation * 10 * direction[0];
                newEnd[1] -= lengthVariation * 10 * direction[1];
                this.updateWall(this.editedWall!.begin, newEnd);
                break;
            case EditionSens.both:
                console.log('Not implemented');
                break;
        }
    }

    updateWall (begin:math.vec3, end: math.vec3) {
        var i, j;
        var wall, position, distOnWall;
        //update Wall for wall at this.wallEdited.begin
        for (i = 0; i < this.editedWallsBegin.length; i++) {
            wall = this.editedWallsBegin[i];
            if (wall.id !== this.editedWall!.id) {

                distOnWall = [];
                if (wall.isBegin(this.editedWall!.begin)) {
                    for (j = 0; j < wall.joineries.length; j++) {
                        distOnWall.push(math.vec3.dist(wall.end, wall.joineries[j].position));
                    }
                    wall.begin = begin;
                    for (j = 0; j < wall.joineries.length; j++) {
                        position = math.vec3.create();
                        position[0] = wall.end[0] - wall.wallDirection[0] * distOnWall[j];
                        position[1] = wall.end[1] - wall.wallDirection[1] * distOnWall[j];

                        wall.joineries[j].position = position;
                    }

                } else {
                    for (j = 0; j < wall.joineries.length; j++) {
                        distOnWall.push(math.vec3.dist(wall.begin, wall.joineries[j].position));
                    }
                    wall.end = begin;
                    for (j = 0; j < wall.joineries.length; j++) {
                        position = math.vec3.create();
                        position[0] = wall.end[0] + wall.wallDirection[0] * distOnWall[j];
                        position[1] = wall.end[1] + wall.wallDirection[1] * distOnWall[j];

                        wall.joineries[j].position = position;
                    }
                }
            }
        }

        //update Wall for wall at this.wallEdited.end
        for (i = 0; i < this.editedWallsEnd.length; i++) {
            wall = this.editedWallsEnd[i];
            if (wall.id !== this.editedWall!.id) {

                distOnWall = [];
                if (wall.isEnd(this.editedWall!.end)) {
                    for (j = 0; j < wall.joineries.length; j++) {
                        distOnWall.push(math.vec3.dist(wall.begin, wall.joineries[j].position));
                    }
                    wall.end = end;
                    for (j = 0; j < wall.joineries.length; j++) {
                        position = math.vec3.create();
                        position[0] = wall.end[0] - wall.wallDirection[0] * distOnWall[j];
                        position[1] = wall.end[1] - wall.wallDirection[1] * distOnWall[j];

                        wall.joineries[j].position = position;
                    }

                } else {
                    for (j = 0; j < wall.joineries.length; j++) {
                        distOnWall.push(math.vec3.dist(wall.end, wall.joineries[j].position));
                    }
                    wall.begin = end;
                    for (j = 0; j < wall.joineries.length; j++) {
                        position = math.vec3.create();
                        position[0] = wall.end[0] + wall.wallDirection[0] * distOnWall[j];
                        position[1] = wall.end[1] + wall.wallDirection[1] * distOnWall[j];

                        wall.joineries[j].position = position;
                    }
                }
            }
        }

        if (this.editionSens === EditionSens.begin) {
            distOnWall = [];
            for (j = 0; j < this.editedWall!.joineries.length; j++) {
                distOnWall.push(math.vec3.dist(this.editedWall!.end, this.editedWall!.joineries[j].position));
            }
            this.editedWall!.begin = begin;
            for (j = 0; j < this.editedWall!.joineries.length; j++) {
                position = math.vec3.create();
                position[0] = this.editedWall!.end[0] - this.editedWall!.wallDirection[0] * distOnWall[j];
                position[1] = this.editedWall!.end[1] - this.editedWall!.wallDirection[1] * distOnWall[j];

                this.editedWall!.joineries[j].position = position;
            }
        } else if (this.editionSens === EditionSens.end) {
            distOnWall = [];
            for (j = 0; j < this.editedWall!.joineries.length; j++) {
                distOnWall.push(math.vec3.dist(this.editedWall!.begin, this.editedWall!.joineries[j].position));
            }
            this.editedWall!.end = end;
            for (j = 0; j < this.editedWall!.joineries.length; j++) {
                position = math.vec3.create();
                position[0] = this.editedWall!.begin[0] + this.editedWall!.wallDirection[0] * distOnWall[j];
                position[1] = this.editedWall!.begin[1] + this.editedWall!.wallDirection[1] * distOnWall[j];

                this.editedWall!.joineries[j].position = position;
            }
        } else {
            this.editedWall!.begin = begin;
            this.editedWall!.end = end;
        }
    }
    dispose () {
        if (!this.editionDone) {
            this.commitChange();
        }
    }
}
